import Vue from 'vue'
import { memberService } from '@/services/member'

export const userStore = Vue.observable({
  profile: null,
  loading: false,
  // Cash wallet balance (get-member-info -> point1); null until loaded
  wallet: null
})

let pending = null

export function fetchProfile (force = false) {
  if (userStore.profile && !force) return Promise.resolve(userStore.profile)
  if (pending) return pending

  userStore.loading = true
  pending = memberService.getProfile()
    .then(data => {
      userStore.profile = data || {}
      return userStore.profile
    })
    .finally(() => {
      userStore.loading = false
      pending = null
    })
  return pending
}

export function setWallet (info) {
  userStore.wallet = info && info.point1 !== undefined ? info.point1 : null
}

// Reads the cash wallet balance. Call with force after anything that moves money.
let walletPending = null
export function fetchWallet () {
  if (walletPending) return walletPending
  walletPending = memberService.getMemberInfo()
    .then(info => {
      setWallet(info)
      return userStore.wallet
    })
    .finally(() => { walletPending = null })
  return walletPending
}

export function clearProfile () {
  userStore.profile = null
  userStore.wallet = null
}
